// TODO: figure out types for URL manager
export var BannerType;
(function (BannerType) {
    BannerType["HEADER"] = "header";
    BannerType["FOOTER"] = "footer";
    BannerType["LEFT"] = "left";
    BannerType["BANNER"] = "banner";
    BannerType["INLINE"] = "inline";
})(BannerType || (BannerType = {}));
export var Layout;
(function (Layout) {
    Layout["GRID"] = "grid";
    Layout["LIST"] = "list";
})(Layout || (Layout = {}));
export var FacetMultiple;
(function (FacetMultiple) {
    FacetMultiple["SINGLE"] = "single";
    FacetMultiple["OR"] = "or";
    FacetMultiple["AND"] = "and";
})(FacetMultiple || (FacetMultiple = {}));
export var FacetType;
(function (FacetType) {
    FacetType["VALUE"] = "value";
    FacetType["RANGE"] = "range";
    FacetType["RANGE_BUCKETS"] = "range-buckets";
})(FacetType || (FacetType = {}));
// TODO: should be added to the Facet type
export var FacetDisplay;
(function (FacetDisplay) {
    FacetDisplay["GRID"] = "grid";
    FacetDisplay["PALETTE"] = "palette";
    FacetDisplay["LIST"] = "list";
    FacetDisplay["SLIDER"] = "slider";
    FacetDisplay["HIERARCHY"] = "hierarchy";
})(FacetDisplay || (FacetDisplay = {}));
